<script setup lang="ts">
	import { computed } from 'vue';
	import { useRoute } from 'vue-router';
	import { useI18n } from 'vue-i18n';
	import { MzBreadcrumb } from '@monizze/monizze-components';
	import type { RouteLocationRaw } from 'vue-router';

	export type BreadcrumbSegment = { label: string; to?: RouteLocationRaw };

	const route = useRoute();
	const { t } = useI18n();

	const items = computed(() => {
		const segments = (route.meta?.breadcrumb as BreadcrumbSegment[] | undefined) ?? [];
		return segments.map((seg) => ({
			label: t(seg.label),
			...(seg.to ? { to: seg.to } : {}),
		}));
	});
</script>

<template>
	<mz-breadcrumb v-if="items.length > 0" :items="items" />
</template>
